import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Updates.css";
import Footer from "../../components/shared/Footer";
import MobileTopBar from "../../components/mobile/MobileTopBar";
import useResponsive from "../../hooks/useResponsive";
import { firmwareUpdates } from "../../Data/siteContent";

function Updates({ feature }) {
  const isMobile = useResponsive();
  const { productName, firmwareVersion, firmwareDate, firmwareFile, updateSteps, settingsEditorSlug } = feature;
  const firmwareFileName = firmwareFile.split("/").pop();
  const settingsEditorLink = settingsEditorSlug ? `/products/${productName.toLowerCase()}/${settingsEditorSlug}` : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const content = (
    <div className="updates__container">
      <h1 className="updates__title">{firmwareUpdates.title.replace("{device}", productName)}</h1>
      <section className="updates__info">
        <p>
          <strong>{firmwareUpdates.currentVersion}</strong> <span className="updates__version">{firmwareVersion}</span>{" "}
          <br />
          <strong>{firmwareUpdates.releaseDate}</strong> {firmwareDate}
        </p>
        <p>
          {firmwareUpdates.noUpdateNeeded.replace("{device}", productName)}
          <br />
          {firmwareUpdates.futureUpdates}
        </p>
        <button
          className="updates__button"
          onClick={() => {
            const link = document.createElement("a");
            link.href = firmwareFile;
            link.download = firmwareFileName;
            link.click();
          }}
        >
          {firmwareUpdates.downloadButton.replace("{version}", firmwareVersion)}
        </button>
      </section>

      <section className="updates__instructions">
        <h2>{firmwareUpdates.howToUpdate}</h2>
        <ol>
          {updateSteps.map((step, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: step }} />
          ))}
        </ol>
        <p className="updates__note">
          <strong>Note:</strong>{" "}
          {settingsEditorLink
            ? <>
                {firmwareUpdates.settingsNoteBefore.replaceAll("{device}", productName)}{" "}
                <Link to={settingsEditorLink}>{firmwareUpdates.settingsEditorLinkText}</Link>
              </>
            : firmwareUpdates.settingsNoteNoLink.replaceAll("{device}", productName)}
        </p>
      </section>
    </div>
  );

  if (isMobile) {
    return (
      <div>
        <MobileTopBar />
        {content}
        <Footer />
      </div>
    );
  }

  return content;
}

export default Updates;
